<template>
  <v-card :class="['store-card', mode]" light :to="to_link" flat :ripple="{ class: 'white--text' }">
    <template v-if="isBrandManager && mode =='edit'">
      <v-list-item>
        <v-list-item-avatar class="avatar small">
          <SpotS3Image :image-path="brand.image"></SpotS3Image>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{store.name}}</v-list-item-title>
          <v-list-item-subtitle> {{manager_info}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-expand-x-transition>
          <div v-if="toggleActions"
               class=" transition-fast-in-fast-out white v-card--reveal primary--text"
               style="height: 100%;">
            <div class="action-btns">
              <v-btn :loading="loadingState" v-if="isBrandManagerOfStore(store.id) || isStoreManagerOfStore(store.id)"
                     large text
                     color="primary"
                     :to="{name:PAGE_IDS.STORE_EDIT, params:{store_id:store.id}}">
                <v-icon>edit</v-icon>
                Edit
              </v-btn>
              <v-btn :loading="loadingState" v-if="isBrandManagerOfStore(store.id)" large text color="error"
                     @click.native.prevent="deleteStore">
                <v-icon>delete</v-icon>
                Delete
              </v-btn>
            </div>
          </div>
        </v-expand-x-transition>
      </v-list-item>


      <v-col class="actions">
        <v-btn large icon color="primary"
               @click.prevent.native="toggleActions =!toggleActions">
          <v-icon>more_vert</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-else>
      <div class="reservation_dt" v-if="mode=='reservation' || mode=='reservation_details'">
        <v-sheet dark align="center" :class="['status', reservation_status]">
          <div>
            <v-icon class="mx-1">schedule</v-icon>
            {{formatted_reservation_dt}}
          </div>
          <v-spacer></v-spacer>
          <div class="text-uppercase">
            {{reservation_status}}
          </div>
        </v-sheet>
      </div>
      <div class="store-tile">
        <v-list-item>
          <v-list-item-avatar class="avatar small">
            <SpotS3Image :image-path="brand.image"></SpotS3Image>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{brand.name}}</v-list-item-title>
            <v-list-item-subtitle> {{store.address}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-row v-if="mode =='reservation' && reservation_status =='Active' " justify="center">
          <v-col cols="12" lg="4" md="6" align="center">
            <canvas ref="canvas"></canvas>
          </v-col>
        </v-row>
        <div v-if="mode !=='reservation' && mode !=='information'" class="map-container">
          <GmapMap :options="{
                    streetViewControl: false,
                    mapTypeControl: false,
                    zoomControl: false,
                    fullscreenControl: false,
                    gestureHandling : 'none',}" :center="{lat:store.lat, lng:store.lng}" :zoom="16"
                   map-type-id="terrain">
            <GmapMarker :clickable="false" :draggable="false" :position="{lat:store.lat, lng:store.lng}"/>
          </GmapMap>
          <div class="distance" v-if="show_distance">{{distance}} mi away</div>
        </div>
        <div>
          <div>
            <div class="headline-container">
              <div class="title">
                <template v-if="mode == 'edit' || mode =='details'"><br/>{{store.name}}</template>
              </div>
            </div>
          </div>
          <v-card-actions>
            <v-btn v-if="mode != 'details' && isBrandManagerOfStore(store.id)" fab
                   small color="primary" :to="{name:PAGE_IDS.STORE_DETAILS, params:{store_id:store.id}}">
              <v-icon>login</v-icon>
            </v-btn>
            <v-btn :loading="loadingState" v-if="isBrandManagerOfStore(store.id) || isStoreManagerOfStore(store.id)" fab
                   small color="primary"
                   :to="{name:PAGE_IDS.STORE_EDIT, params:{store_id:store.id}}">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn :loading="loadingState" v-if="isBrandManagerOfStore(store.id)" fab
                   small color="error"
                   @click.native.prevent="deleteStore">
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn depressed color="primary" class="full-width-button" v-if="mode == 'visit'"
                   :to='{name: PAGE_IDS.RESERVATION_ADD, params: {store_id: store.id}}'>
              <img src="/static/logo_small.png" alt="logo">
              Save Spot
            </v-btn>
            <v-spacer v-if="mode=='visit'"></v-spacer>
            <v-btn :loading="loadingState  && favorite_store == store.id" v-if="mode=='visit'"
                   :color=" is_in_favorites?'#ff7bac' :'#C1C1C1'"
                   @click.stop.prevent.native="changeFavoritesStatus"
                   right icon>
              <v-icon>favorite</v-icon>
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </template>
  </v-card>
</template>

<script>
  import {doDeleteStore, deleteFavorite, doAddToFavorites} from "../graphql/mutations";
  import {process_api_error, calculateStoreStatus} from "@/utils/utils"
  import {mapGetters} from "vuex";
  import {gmapApi} from 'vue2-google-maps'
  import {PAGE_IDS, determineStatusValue, RESERVATION_STATUS} from "../utils/constants"
  import SpotS3Image from "../Pages/SpotS3Image";
  import Vue from "vue";
  import {getStore} from "../graphql/queries";
  import { DateTime } from "luxon";

  var QRCode = require('qrcode')
  const moment = require('moment-timezone')

  export default {
    name: "StoreTile",
    data: () => ({
      favorite_store: undefined,
      toggleActions: false
    }),
    components: {SpotS3Image},
    props: ["store", "mode", "distance", "reservation"],
    computed: {
      ...mapGetters(['loadingState', 'isStoreManager', 'isBrandManager', 'isSecurity', 'isVisitor', 'getBrandById',
        'isBrandManagerOfStore', 'isStoreManagerOfStore', 'allFavorites', 'isReservationOwner', 'currentUser']),
      storeOpenStatus() {
        return calculateStoreStatus(this.store)
      },
      manager_info() {
        if (this.store.storemanagers.length == 0) {
          return "No Managers Defined"
        }
        if (this.store.storemanagers.length == 1) {
          return "1 Manager"
        } else {
          return this.store.storemanagers.length + " managers"
        }
      },
      show_distance() {
        return this.mode == 'visit' && this.distance != undefined
      },
      brand() {
        return this.getBrandById(this.store.brand_id)
      },
      to_link() {
        if (this.mode == 'reservation') {
          if (this.isReservationOwner(this.reservation.id)) {
            return {"name": PAGE_IDS.RESERVATION_DETAIL, params: {reservation_id: this.reservation.id}}
          }
        } else if (this.mode == 'visit') {
          return {name: PAGE_IDS.RESERVATION_ADD, params: {store_id: this.store.id}}
        }
        if (this.isBrandManager) {
          return {"name": PAGE_IDS.STORE_DETAILS, params: {store_id: this.store.id}}
        }
        return undefined
      },
      is_in_favorites() {
        return this.favorites_record != undefined
      },
      favorites_record() {
        return this.allFavorites.find((item) => item.store_id == this.store.id)
      },
      formatted_reservation_dt() {
        if(this.reservation.dt > 1639521000){
        var storeUTCTime = DateTime.fromSeconds(this.reservation.dt, {zone: "UTC"});
        var storeTimezone = storeUTCTime.setZone(this.store.timezone)
        var reservationDateFormate = storeTimezone.toFormat('ccc, LLL dd, h:mma');
        return reservationDateFormate;
        }else{
          return moment(new Date(this.reservation.dt * 1000)). format('ddd, MMM DD, h:mma');
        }
        // return moment(new Date(this.reservation.dt * 1000)). format('ddd, MMM DD, h:mma');
        // return moment.utc(this.reservation.dt * 1000).format("ddd, MMM DD, h:mma")
      },
      reservation_status() {

        return determineStatusValue(this.reservation, this.store)
      }
    },
    methods: {
      active() {
        if (this.reservation) {
          
          var status = determineStatusValue(this.reservation, this.store)
          if((status == RESERVATION_STATUS.ACTIVE) || (status == RESERVATION_STATUS.IN_STORE) || (status == RESERVATION_STATUS.AUTOEXIT)){
            // console.log("time zone : ",this.store.timezone);
          }
          
          return ((status == RESERVATION_STATUS.ACTIVE) || (status == RESERVATION_STATUS.IN_STORE) || (status == RESERVATION_STATUS.AUTOEXIT))
        } else {
          return false;
        }
      },
      changeFavoritesStatus() {
        var that = this
        this.$store.dispatch('startLoading')
        this.favorite_store = this.store.id

        if (this.is_in_favorites) {

          this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(deleteFavorite, {input: {id: this.favorites_record.id}}))
            .then(() => {
              this.$store.dispatch('removeFavorite', that.favorites_record.id)
              this.$store.dispatch('stopLoading')
              this.favorite_store = undefined
            })
            .catch((e) => {
              this.$store.dispatch('stopLoading')
              process_api_error(`Error Deleting Favorite`, e)
            });
        } else {
          this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(doAddToFavorites, {
            store_id: this.store.id,
            owner: this.currentUser.username,
            dt: moment.utc(moment.utc().format("YYYY-MM-DDTHH:mm")).unix()
          }))
            .then((res) => {
              this.$store.dispatch('addFavorite', res.data.doAddToFavorites)
              this.$store.dispatch('stopLoading')
              this.favorite_store = undefined
            })
            .catch((e) => {
              this.$store.dispatch('stopLoading')
              process_api_error(`Error Adding Favorite`, e)
            });
        }
      },
      deleteStore() {
        var that_mode = this.mode;
        var that = this;
        var store_id = that.store.id
        if (that.$route.name == PAGE_IDS.STORE_DETAILS) {
          this.$router.push({name: PAGE_IDS.STORES_LIST})
        }
        this.$store.dispatch('removeStore', store_id)
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(doDeleteStore, {id: store_id}))
          .then((response) => {
          })
          .catch((e) => {
              Vue.prototype.$Amplify.API.graphql(Vue.prototype.$Amplify.graphqlOperation(getStore, {id: store_id}))
              .then((res) => {
                this.$store.dispatch('addStore', res.data.getStore)
              })
            process_api_error(`Error Deleting Store`, e)
          });
      }
    },
    mounted() {
      if (this.active()) {
        QRCode.toCanvas(this.$refs.canvas, this.reservation.id, {
          errorCorrectionLevel: 'H',
          scale: 3
        }, function (error) {
          if (error) console.error(error)
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .store-card {

    .v-list-item {
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;

      .v-list-item__title {
        font-weight: 600;

      }


    }

    &:active {
      .v-list-item__subtitle {
        color: var(--v-primary-base) !important;
      }
    }

    &:not(.information) {

    }


  }

  .information {
    .v-list-item__subtitle {
      color: #37474F;
    }
  }

  .routerLink {
    text-decoration: none;
  }


</style>
<style lang="scss">
  .full-width-button {
    font-size: 12px;
    margin: 4px 0 8px 8px;

    img {
      margin-right: 6px;
      height: 24px;
      width: 24px;
    }
  }

  .store-card.visit {
    .second-text {
      margin-top: -10px;
    }
  }


  .store-card {
    &.visit {
      border-radius: 15px !important;

      .store-tile {
        border-radius: 15px !important;
      }
    }

    .vue-map {
    }

    .second-text {
      font-size: 0.65rem;
      padding-left: 2.5rem;
      padding-right: 1.5rem;
      line-height: 0.9rem;

      .part2 {
        padding-top: 0.4rem;
      }

      .status {
        font-size: 0.9rem;
        font-weight: bold;

        &.Active {
          color: #76CD79
        }

        &.Expired {
          color: #FE6868
        }

        &.In.Store {
          color: #fbb040
        }

        &.Completed {
          color: #76CD79
        }

        &.Cancelled {
        }
      }
    }
  }

  .headline-container {
    line-height: 30px;
    padding-top: 0.5rem;

    .title {
      line-height: 30px;
    }

    .amplify-image {
      width: auto !important;
      max-height: 30px !important;
      min-height: 30px !important;
      border-radius: 0px !important;
      margin: 0px !important;
      border: 0px solid white

    }
  }

  .distance {
    border-radius: 10px;
    position: absolute;
    z-index: 3;
    top: 80px;
    left: 10px;
    font-size: 0.8rem;
    background-color: #1765C0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/Stores/StoreTile.vue